export const safeRequestIdleCallback = (callback, options) => {
  if (typeof window !== 'undefined' && window.requestIdleCallback) {
    return window.requestIdleCallback(callback, options);
  }
  const timeout = options?.timeout || 1000;
  return setTimeout(callback, 100);
};
